import React from "react";
import ReactDOM from "react-dom";
import App from "./app.js";
import "./create-account.css";

ReactDOM.render(<App />, document.getElementById("create_account_root"));
